import styled from 'styled-components';
import { Chip } from '@mui/material';
import {
  ChevronRight as ChevronRightIcon,
  ChevronLeft as ChevronLeftIcon,
} from '@mui/icons-material';

import colors from '../../../../styles/colors';

const COLLAPSED_BAR_WIDTH = 50;

const PanelContainer = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  width: ${({ $width }) => $width}px;
  z-index: 1200;
  display: flex;
  flex-direction: row;
  background-color: ${colors.base.secondary3};
  border-left: 1px solid ${colors.shades.secondary4};
`;

const CollapsedBar = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  width: ${COLLAPSED_BAR_WIDTH}px;
  z-index: 1200;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 10px;
  gap: 10px;
  background-color: ${colors.base.secondary2};
  border-left: 1px solid ${colors.shades.secondary4};
  cursor: pointer;

  &:hover {
    background-color: ${colors.shades.secondary8};
  }
`;

const ExpandedPanel = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow: hidden;
`;

const ResizeHandle = styled.div`
  position: absolute;
  left: -3px;
  top: 0;
  bottom: 0;
  width: 6px;
  cursor: col-resize;
  z-index: 10;

  &::after {
    content: '';
    position: absolute;
    left: 2px;
    top: 0;
    bottom: 0;
    width: 2px;
    background-color: transparent;
    transition: background-color 0.2s;
  }

  &:hover::after {
    background-color: ${colors.shades.primary4};
  }
`;

const PanelHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px 15px;
  background-color: ${colors.base.secondary2};
  border-bottom: 1px solid ${colors.shades.secondary4};
  gap: 8px;
`;

const StyledUnreadCount = styled(Chip)`
  && {
    background-color: ${colors.shades.primary3};
    border: 1px solid ${colors.shades.primary4};
    font-weight: 600;
    font-size: 12px;
    line-height: 14px;

    &:hover {
      background-color: ${colors.shades.primary4};
    }
  }
`;

const PanelContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow: hidden;
`;

const StyledChevronRightIcon = styled(ChevronRightIcon)`
  color: ${colors.shades.gamma2};
`;

const StyledChevronLeftIcon = styled(ChevronLeftIcon)`
  color: ${colors.shades.gamma2};
`;

export {
  PanelContainer,
  CollapsedBar,
  ExpandedPanel,
  ResizeHandle,
  PanelHeader,
  StyledUnreadCount,
  PanelContent,
  COLLAPSED_BAR_WIDTH,
  StyledChevronRightIcon,
  StyledChevronLeftIcon,
};
